import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "map-view-selector__list" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "map-view-selector__option-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_button_icon = _resolveComponent("c-button-icon")!
  const _component_c_dropdown = _resolveComponent("c-dropdown")!

  return (_openBlock(), _createBlock(_component_c_dropdown, {
    placement: _ctx.placement,
    "hide-animation": _ctx.hideAnimation,
    "shadow-root": _ctx.shadowRoot,
    onChangeVisibility: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dropdownTriggerActive = $event))
  }, {
    trigger: _withCtx(({ toggleVisibility }) => [
      _createVNode(_component_c_button_icon, {
        type: _ctx.buttonIconType,
        color: _ctx.buttonIconColor,
        "icon-name": _ctx.faLayerGroup.iconName,
        "is-active": _ctx.dropdownTriggerActive,
        onClick: ($event: any) => (toggleVisibility())
      }, null, 8, ["type", "color", "icon-name", "is-active", "onClick"])
    ]),
    content: _withCtx(({ toggleVisibility }) => [
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewOptions, (option) => {
          return (_openBlock(), _createElementBlock("li", {
            key: option.value,
            class: _normalizeClass(["map-view-selector__option", { 'map-view-selector__option--active': option.value === _ctx.currentView }]),
            onClick: ($event: any) => {
						_ctx.$emit(_ctx.ComponentEvent.CHANGE_VIEW, option.value);
						toggleVisibility();
					}
          }, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(option.label), 1)
          ], 10, _hoisted_2))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["placement", "hide-animation", "shadow-root"]))
}